import React, { Fragment } from "react";

import classNames from "classnames";

import { Typography } from "clearsense-ui/components";

import BusinessRuleTooltip from "./BusinessRuleTooltip";
import FieldTooltip from "./FieldTooltip";

const NormalField = ({ field, fields, index, businessRules }) => (
  <div
    key={field}
    className={classNames("flex space-x-2 px-2 pb-4 items-start", {
      "pt-4": index === 0,
    })}
  >
    <BusinessRuleTooltip
      businessRule={businessRules?.[fields[field].display_name]}
    >
      <Typography style="medium" className="text-shades-darkest flex-shrink-0">
        {fields[field].display_name}:
      </Typography>
    </BusinessRuleTooltip>

    <Typography style="medium" className="text-primary-shade">
      {fields[field]?.cde_values?.map(
        ({ value, cde_source_system, cde_updated_date }, valueIndex) => (
          <Fragment key={valueIndex}>
            <FieldTooltip
              value={value}
              cde_source_system={cde_source_system}
              cde_updated_date={cde_updated_date}
              valueIndex={valueIndex}
              field={field}
              fields={fields}
            >
              <Typography
                style="medium"
                className="inline-block cursor-default"
              >
                {value}
              </Typography>
            </FieldTooltip>
            {valueIndex === fields[field]?.cde_values?.length - 1 ? "" : ", "}
          </Fragment>
        )
      )}
    </Typography>
  </div>
);

export default NormalField;
